import { isExploraPath, startExploraLoader } from '@/lib/exploraLoader';

import { loadCasaLineas } from './exploraLoaderSteps';
import { loadLugarMap } from './loadLugarMap';

/**
 * Landing on Explora: the loader goes up with our first line of code, and everything the page needs starts downloading
 * at once instead of one chunk after the other (the layout, then its section, then the map).
 */
export function bootExplora(pathname: string) {
  if (!isExploraPath(pathname)) return;
  startExploraLoader();
  const ignore = () => {};
  // the loader's drawing first (small, it is what shows), then the map (the heaviest), then the page around it
  loadCasaLineas().catch(ignore);
  const map = pathname.startsWith('/locaciones');
  if (map) loadLugarMap().catch(ignore);
  import('./ExploraLayout').catch(ignore);
  if (map) import('./LocacionesSection').catch(ignore);
}
